const AuthConstants = require('./constants');
const AuthPersistence = require('./persistence');
const Policy = require('./policy');
const Continuation = require('./continuation');

const internals = {};

module.exports = {
    buildEmailChange,
    buildSuccessfulAuthentication,
    buildWelcomeLinkEntry,
    completeSuccessfulAuthentication,
    resetForEmailChange,
    resetForWelcomeLink
};

function resetForEmailChange(email) {

    const loginContext = internals.getLoginContext();
    const signupContext = internals.getSignupContext();
    const submittedEmail = Policy.normalizeEmail(email);
    const currentIdentityEmails = [
        loginContext.email,
        signupContext.email
    ]
        .map(Policy.normalizeEmail)
        .filter(Boolean);

    if (currentIdentityEmails.length
        && currentIdentityEmails.every((currentEmail) => currentEmail === submittedEmail)) {
        return false;
    }

    return internals.apply(buildEmailChange({
        email,
        lastLoginEmail: loginContext.lastLoginEmail
    }));
}

function resetForWelcomeLink() {

    const loginContext = internals.getLoginContext();

    return internals.apply(buildWelcomeLinkEntry({
        lastLoginEmail: loginContext.lastLoginEmail
    }));
}

function completeSuccessfulAuthentication(email) {

    const continuation = Continuation.peek();

    internals.apply(buildSuccessfulAuthentication({ email }));

    return continuation;
}

internals.apply = (transition) => {

    const context = internals.getAppContext();
    const actions = context.actions;
    const redux = context.redux.hooks;

    AuthPersistence.clearTransientAuthState();
    redux.dispatch(actions.auth.updateLoginContext(transition.loginContext));
    redux.dispatch(actions.signup.initContext(transition.signupContext));

    return transition;
};

function buildEmailChange({ email, lastLoginEmail } = {}) {

    return {
        loginContext: internals.buildLoginContext({
            email,
            lastLoginEmail
        }),
        signupContext: {
            ...AuthConstants.signupContext.resetFields,
            email,
            schoolId: null
        }
    };
}

function buildWelcomeLinkEntry({ lastLoginEmail } = {}) {

    return {
        loginContext: internals.buildLoginContext({ lastLoginEmail }),
        signupContext: {}
    };
}

function buildSuccessfulAuthentication({ email } = {}) {

    const normalizedEmail = Policy.normalizeEmail(email);

    return {
        loginContext: internals.buildLoginContext({
            email: normalizedEmail,
            lastLoginEmail: normalizedEmail
        }),
        signupContext: {}
    };
}

internals.buildLoginContext = ({ email = null, lastLoginEmail } = {}) => ({
    ...AuthConstants.loginContext.runtimeResetFields,
    email,
    lastLoginEmail: Policy.normalizeEmail(lastLoginEmail)
});

internals.getAppContext = () => require('app-context').context;

internals.getLoginContext = () => {

    const context = internals.getAppContext();
    const redux = context.redux.hooks;
    const selectors = context.selectors.all;

    return selectors.getLoginContext?.(redux.getState()) || {};
};

internals.getSignupContext = () => {

    const context = internals.getAppContext();
    const redux = context.redux.hooks;
    const selectors = context.selectors.all;

    return selectors.getSignupContext?.(redux.getState()) || {};
};
